export enum ECustomer {
  updateCustomer = 'customer/updateCustomer',
}
